var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.5834C22.5029 15.6832 22.2459 16.7683 21.75 17.75C21.162 18.9265 20.2581 19.916 19.1395 20.6078C18.021 21.2995 16.7319 21.6662 15.4167 21.6667C14.3168 21.6696 13.2318 21.4126 12.25 20.9167L7.5 22.5L9.08333 17.75C8.58744 16.7683 8.33047 15.6832 8.33333 14.5834C8.33384 13.2682 8.70051 11.9791 9.39227 10.8605C10.084 9.7419 11.0735 8.838 12.25 8.25002C13.2318 7.75413 14.3168 7.49716 15.4167 7.50002H15.8333C17.5703 7.59585 19.2109 8.32899 20.4409 9.55907C21.671 10.7892 22.4042 12.4297 22.5 14.1667V14.5834Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessager);
export default __webpack_public_path__ + "static/media/messager.cbb4c237ce3edd121d85491839d5342e.svg";
export { ForwardRef as ReactComponent };